import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TRRDialogInput, TRRDialogOutput } from '../../../models/DialogData';
import { Constants } from '../../../constants/constants';
import { Popover, Tooltip } from 'bootstrap';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

type PopoverPlacement = 'top' | 'bottom' | 'left' | 'right' | 'auto';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './trr-dialog.component.html',
  styleUrls: ['./trr-dialog.component.scss'],
  imports: [
    CommonModule,
      MatButtonModule,
      MatDialogActions, 
      MatDialogClose, 
      MatDialogTitle, 
      MatDialogContent,
      MatIcon,
      MatRadioGroup,
      MatRadioButton,
      FormsModule,
      ReactiveFormsModule,
      TranslatePipe
     ]
})
export class TrrDialogComponent {
  THOUSAND:number = 1000;
  MILLION:number = 1000000;
  BILLION:number = 1000000000;
  TRILLION:number = 1000000000000;


  trrInfoMessageTemplateString: string = '';
        
  selectedRadioOption: string = '';

  constructor(private currencyPipe: CurrencyPipe,public dialogRef: MatDialogRef<TrrDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TRRDialogInput, private translate: TranslateService) { }

    ngOnInit() {
      this.setTrrThresholds();
      this.selectedRadioOption = this.data.selectedRadioOption;
    }

    setTrrThresholds(){
      const { security, fire, firePartsAndSmarts, automation, electrical, mechanical } = this.data.trrThresholds;
      this.trrInfoMessageTemplateString = `
        <div class="popover" role="tooltip">
          > Security <br>
          &nbsp;&nbsp;&nbsp;&nbsp; Base Branches >${this.formattedValue(security)} <br>
          &nbsp;&nbsp;&nbsp;&nbsp; Enhanced Branches >$150K <br>
          &nbsp;&nbsp;&nbsp;&nbsp; Premier Branches >$500K <br>
          > Fire Turnkey: ${this.formattedValue(fire)} <br>
          > Fire Parts &amp; Smarts: ${this.formattedValue(firePartsAndSmarts)} <br>
          > Automation: ${this.formattedValue(automation)} <br>
          > Electrical: ${this.formattedValue(electrical)} <br>
          > Mechanical: ${this.formattedValue(mechanical)} <br>
        </div>`;
    }

    
  formattedValue(value:number): string {
    if (value >= this.TRILLION) {
      return  this.appendCurrencySymbol(value / this.TRILLION) || this.appendCurrencySymbol(Constants.ZERO_DECIMAL) || Constants.EMPTY_STRING;
    } else if (value >= this.BILLION) {
      return this.appendCurrencySymbol(value / this.BILLION) || this.appendCurrencySymbol(Constants.ZERO_DECIMAL) || Constants.EMPTY_STRING;
    } else if (value >= this.MILLION) {
      return this.appendCurrencySymbol(value / this.MILLION) || this.appendCurrencySymbol(Constants.ZERO_DECIMAL) || Constants.EMPTY_STRING;
    } else if (value >= this.THOUSAND) {
      return this.appendCurrencySymbol(value / this.THOUSAND) || this.appendCurrencySymbol(Constants.ZERO_DECIMAL) || Constants.EMPTY_STRING;
    } else {
      return this.appendCurrencySymbol(value) || this.appendCurrencySymbol(Constants.ZERO_DECIMAL) || Constants.EMPTY_STRING;
    }
  }

  
  appendCurrencySymbol(value: string | number): string | null {
    return this.currencyPipe.transform(value, this.translate.instant('COMMON_LABELS.CURRENCY'), 'symbol-narrow', '', this.translate.instant('COMMON_LABELS.LOCALE_CODE'));
  }

    onOkClick() {
      let output = new TRRDialogOutput();
      output.button = Constants.OK;
      output.selectedRadioOption = this.selectedRadioOption;
      this.dialogRef.close(output);
    }

    onCancelClick() {
      let output = new TRRDialogOutput();
      output.button = Constants.CANCEL;
      this.dialogRef.close(output);
    }

    initializePopover(event: Event): void {
      const element = event.target as HTMLElement;
      const template = document.createElement(Constants.DIV);
      template.innerHTML = this.trrInfoMessageTemplateString;
      let popover = new Popover(element, {
        content: template.innerHTML,
        html: true,
        placement: Constants.BOTTOM as PopoverPlacement,
      });
      popover.show();
    }

    destroyPopover(event: Event): void {
      const element = event.target as HTMLElement;
      const popover = Popover.getInstance(element);
      if (popover) {
        popover.dispose();
      }
    }
}
